import {
  customElement,
  DeesElement,
  property,
  html,
  cssManager,
  unsafeCSS,
  css,
  until,
  unsafeHTML,
  TemplateResult,
} from '@design.estate/dees-element';

import * as plugins from '../plugins.js';

@customElement('philkunz-cv')
export class PhilkunzCv extends DeesElement {
  constructor() {
    super();
  }

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        display: block;
        display: block;
        min-height: 48px;
        border-bottom: 1px solid;
        border-image: radial-gradient(circle, #88888840, #88888800) 1;
        color: ${cssManager.bdTheme('#333', '#fff')};
      }
      :host([hidden]) {
        display: none;
      }

      .maincontainer {
        min-height: 40px;
        max-width: 1200px;
        margin: auto;
        font-family: 'Geist Sans';
        line-height: 1.5em;
      }

      .markdownContainer {
        border: 1px dotted #333;
        max-width: 66%;
        padding: 24px;
        margin: 40px 0px;
        border-radius: 3px;
      }

      .markdownContainer h1, h2 {
        font-family: 'Geist Sans';
        font-weight: 400;
        max-width: 600px;
      }

      .markdownContainer h1::after {
        display: block;
        content: '';
        height: 3px;
        width: 64px;
        border-radius: 3px;
        background: #e4002b;
        margin: 24px 0px;
      }

      .markdownContainer blockquote {
        margin: 0px;
      }

      .markdownContainer ul {
        margin: 0px;
        padding-left: 16px;
      }

      .markdownContainer a {
        color: #ccc;
      }

    `,
  ];

  public render(): TemplateResult {
    return html`
      <style></style>
      <div class="maincontainer">
        <div class="markdownContainer">
          ${until(
            (async () => {
              const webrequestInstance = new plugins.webrequest.WebRequest();
              const mdResponse = await webrequestInstance.request('/cv.md', {
                method: 'GET',
              });
              if (!mdResponse) {
                return `Could not get CV data!`
              }
              const mdString = await mdResponse.text();
              return unsafeHTML(
                await plugins.smartmarkdown.SmartMarkdown.easyMarkdownToHtml(mdString)
              );
            })()
          )}
        </div>
      </div>
    `;
  }
}
